import { EQUIPMENT_RENTAL_NO_AGREEMENT_ID } from '../constants/equipmentRental.constants';
import type { EquipmentRentalAgreementOption } from '../types/equipmentRental.types';

function isAgreementMarkedDefault(agreement: EquipmentRentalAgreementOption): boolean {
  const row = agreement as EquipmentRentalAgreementOption & { isDefault?: boolean };

  return row.is_default === true || row.isDefault === true;
}

/** Shelter default rental agreement id, or the synthetic "no agreement" sentinel. */
function resolveDefaultRentalAgreementId(agreements: EquipmentRentalAgreementOption[]): string {
  if (!agreements.length) return EQUIPMENT_RENTAL_NO_AGREEMENT_ID;

  const marked = agreements.find(isAgreementMarkedDefault);

  return marked?._id ?? agreements[0]?._id ?? EQUIPMENT_RENTAL_NO_AGREEMENT_ID;
}

/**
 * True when checkout should auto-select the shelter default (the line was never assigned an
 * agreement). We deliberately do NOT treat `EQUIPMENT_RENTAL_NO_AGREEMENT_ID` as a trigger here:
 * it's a legitimate user choice from the picker, not a placeholder. Otherwise the watcher that
 * calls this (sync on every `equipment_lines` mutation) would clobber an explicit "No agreement
 * required" pick with the shelter default the next time the staff added another line.
 */
function shouldApplyDefaultRentalAgreement(
  currentAgreementId: string | undefined,
  defaultAgreementId: string
): boolean {
  if (defaultAgreementId === EQUIPMENT_RENTAL_NO_AGREEMENT_ID) return false;

  const current = String(currentAgreementId ?? '').trim();

  return current === '';
}

export { isAgreementMarkedDefault, resolveDefaultRentalAgreementId, shouldApplyDefaultRentalAgreement };
